/* global axios */
import ApiClient from '../ApiClient';

class ProspectingAPI extends ApiClient {
  constructor() {
    super('agno/prospecting', { accountScoped: true });
  }

  // Gera uma sugestão de mensagem (1º contato / follow-up) com IA, a partir do nicho.
  // `network` ajusta o tom (whatsapp/instagram/facebook); default é 'whatsapp'.
  generateCopy({ niche, location, kind, network }) {
    return axios.post(`${this.url}/generate_copy`, {
      niche,
      location,
      kind,
      network,
    });
  }
}

export default new ProspectingAPI();
